import React, { PureComponent, Fragment } from 'react'
import { Redirect } from 'react-router-dom'
import cn from 'classnames'
import { withStyles } from '@material-ui/core'

import { Header, RoutesTabs } from 'components'

import { SIGNIN } from 'constants/urls'

const styles = theme => ({
  main: {
    minWidth: 1280,
    margin: `${theme.spacing.unit * 5}px ${theme.spacing.unit * 4}px`
  },

  margin: {
    margin: `${theme.spacing.unit * 10}px ${theme.spacing.unit * 4}px`
  }
})

class SignedInLayoutBase extends PureComponent {
  componentDidMount() {
    const { getRoutes, isSignedIn, getAllCities, allCities } = this.props

    if (isSignedIn) {
      getRoutes()
    }

    if (!allCities.length) {
      getAllCities()
    }
  }

  render() {
    const {
      classes, children, isSignedIn, isLogisticPage, userId,
      isPricesPage, isRoutesPage, isBookPage, isClient
    } = this.props

    const showRouteTabs = isPricesPage || isLogisticPage || isRoutesPage

    const haveAccess = isSignedIn && userId && !isClient

    if (!haveAccess) {
      return <Redirect to={SIGNIN} />
    }

    return (
      <Fragment>
        <Header />
        {showRouteTabs && <RoutesTabs />}
        <main className={cn(classes.main, isBookPage && classes.margin)}>
          {children}
        </main>
      </Fragment>
    )
  }
}

export default withStyles(styles)(SignedInLayoutBase)



// WEBPACK FOOTER //
// ./src/layouts/SignedInLayout/SignedInLayout.js